module.exports = __webpack_public_path__ + "static/media/Rotated tooth3.41fa800c.png";